import angular from 'angular';
import uiRouter from 'angular-ui-router';
import descriptionComponent from './description.component';

let descriptionModule = angular.module('description', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.detail.description', {
    url: '/description',
    component: 'description',
    // params: {
    //   item: null,
    //   language: "IT"
    // }
  });
})

.component('description', descriptionComponent)

  .name;

export default descriptionModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/description/description.js